import { cn } from '@/lib/utils';
import { useContext } from 'react';

import { ChainlitContext, useConfig } from '@chainlit/react-client';

import { useTheme } from './ThemeProvider';

interface Props {
  className?: string;
}

// 換 logo 檔（public/logo_{dark,light}.svg）時遞增：/logo 回應沒有 Cache-Control，
// 瀏覽器會依 Last-Modified 啟發式快取數週，只換檔案舊圖會一直留在使用者端。
const LOGO_VERSION = '20260915';

export const Logo = ({ className }: Props) => {
  const { variant } = useTheme();
  const { config } = useConfig();
  const apiClient = useContext(ChainlitContext);
  const endpoint = apiClient.getLogoEndpoint(variant, config?.ui?.logo_file_url);
  // 只對內建 /logo 端點加版本參數；自訂 logo_file_url 原樣使用
  // buildEndpoint 可能已在結尾留一個 '&'（例如 ?theme=dark&），先去掉再接版本參數
  const base = endpoint.replace(/[?&]+$/, '');
  const src = config?.ui?.logo_file_url
    ? endpoint
    : `${base}${base.includes('?') ? '&' : '?'}v=${LOGO_VERSION}`;

  return (
    <img
      src={src}
      alt="logo"
      className={cn('logo', className)}
    />
  );
};
